export const ADD_ORDERS = 'ADD_ORDERS'
export const ADD_ORDER = 'ADD_ORDER'
export const LOAD_ORDER_STATUS = 'LOAD_ORDER_STATUS'
export const SET_CURRENT_ORDER = 'SET_CURRENT_ORDER'
export const UPDATE_ORDER = 'UPDATE_ORDER'